import type { HTMLAttributes } from 'react'
import { MATERIAL_ICONS, type MaterialIconName } from './materialIcons.generated'

interface IconProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  name: MaterialIconName
  /** Logical pixels. Flutter's `Icon` defaults to 24. */
  size?: number
  /** Accessible name. Icons without a label are decorative. */
  label?: string
}

/**
 * Renders a glyph of the same MaterialIcons font the Flutter app ships, addressed by the
 * Flutter `Icons.<name>` name, so both clients draw identical icons.
 */
export function Icon({ name, size = 24, label, className, style, ...rest }: IconProps) {
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true }

  return (
    <span
      {...rest}
      {...a11y}
      className={`material-icon${className ? ` ${className}` : ''}`}
      style={{ fontSize: `${size}px`, ...style }}
    >
      {String.fromCodePoint(MATERIAL_ICONS[name])}
    </span>
  )
}
